export enum FormFieldFeedbackStatus {

    /**
     * 
     */
    Invalid = 'invalid',
    
    /**
     * 
     */
    Valid = 'valid',
}

/**
 * @description Feedback status type
 * @example
 * const feedbackStatus: FormFieldFeedbackStatusType = 'invalid' | 'valid'
 */
export type FormFieldFeedbackStatusType = 'invalid' | 'valid';

/**
 * @description Feedback status type
 * @example
 * const feedbackStatus: IFormFieldFeedbackStatus = 'invalid' | 'valid'
 * const feedbackStatus: IFormFieldFeedbackStatus = FormFieldFeedbackStatus.Invalid
 * const feedbackStatus: IFormFieldFeedbackStatus = FormFieldFeedbackStatus.Valid
 */
export type IFormFieldFeedbackStatus = FormFieldFeedbackStatusType | FormFieldFeedbackStatus;
